import { createColorsContext } from "@superweb/ui";

const [TableValueColors, useTableValueColors] = createColorsContext<{
  pos: string;
  neg: string;
}>({
  light: {
    pos: "#029154",
    neg: "#CC2D32",
  },
  dark: {
    pos: "#0FB775",
    neg: "#D9474B",
  },
});
export { TableValueColors, useTableValueColors };
